export default "__VITE_PUBLIC_ASSET__98ba8f84__"